const PLAIN = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
const ACCENTED = [...'áƀçđéƒĝĥíĵķļɱñöþǫŕšţúṽŵẋýžÁƁÇĐÉƑĜĤÍĴĶĻṀÑÖÞǪŔŠŢÚṼŴẊÝŽ']

// Placeholders ({{amount}}), <Trans> tags (<0>, </1>, <br/>) and i18next nesting
// ($t(key)) must survive untouched, otherwise interpolation breaks.
const PROTECTED = /(\{\{[^}]*\}\}|<\/?\d+\s*\/?>|<\/?[a-zA-Z]+\s*\/?>|\$t\([^)]*\))/

/**
 * `Send {{amount}}` → `[Šéñđ {{amount}} ·····]`. Brackets reveal clipped text, the
 * padding (~40%) simulates German/French length, and accents reveal missing glyphs.
 */
export const pseudoLocalize = (value: string): string => {
  const body = value
    .split(PROTECTED)
    .map((part, index) =>
      index % 2 === 1 ? part : part.replace(/[a-zA-Z]/g, (ch) => ACCENTED[PLAIN.indexOf(ch)] ?? ch)
    )
    .join('')
  const padding = '·'.repeat(Math.max(1, Math.round(value.length * 0.4)))
  return `[${body} ${padding}]`
}

export const pseudoLocalizeResources = (resources: Record<string, string>) =>
  Object.fromEntries(Object.entries(resources).map(([key, value]) => [key, pseudoLocalize(value)]))
